import * as React from 'react';
import { observer } from 'mobx-react';

export interface IListPagerProps {
    canShowLeftArrow: boolean;
    canShowRightArrow: boolean;
    pagesStart: number;
    pagesEnd: number;
    currentPage: number;
    totalPages: number;
    leftArrowClick: () => void;
    rightArrowClick: () => void;
    pageClick: (number: number) => void;
    className?: string;
}

export const ListPager: React.FC<IListPagerProps> = observer((props) => {
    let pages = [];
    let i = props.pagesStart;
    while (i <= props.pagesEnd) {
        pages.push(i);
        i++;
    }
    return (<div className={`Page navigation pagination-wrapper ${props.className}`} >
        <ul className="pagination pull-right w-100 d-flex flex-wrap justify-content-center m-0">
            {
                props.canShowLeftArrow && <li className="paginate_button page-item previous">
                    <a onClick={() => { props.leftArrowClick() }} aria-label="Previous" className="page-link">
                        <span aria-hidden="true">«</span>
                    </a>
                </li>
            }
            {
                pages.map(pi => (<li key={pi} className={`paginate_button page-item ${props.currentPage === pi ? "active" : ""}`}>
                    <a onClick={() => { props.pageClick(pi); }} className="page-link">{pi}{props.currentPage === pi ? " / " + props.totalPages : ""}</a>
                </li>))

            }
            {
                props.canShowRightArrow && <li className="paginate_button page-item next">
                    <a onClick={() => { props.rightArrowClick() }} aria-label="Next" className="page-link">
                        <span aria-hidden="true">»</span>
                    </a>
                </li>
            }
        </ul>
    </div >);
});